import { render } from "./CopyrightWarning.vue?vue&type=template&id=2927ef6c&scoped=true"
import script from "./CopyrightWarning.vue?vue&type=script&lang=ts"
export * from "./CopyrightWarning.vue?vue&type=script&lang=ts"

import "./CopyrightWarning.vue?vue&type=style&index=0&id=2927ef6c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2927ef6c"

export default script